import { Component } from '@angular/core'; import { LoggingService } from 'src/app/shared/services/Logging.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-notfound-page',
  templateUrl: './notfound-page.component.html',
  styleUrls: ['./notfound-page.component.scss']
})
export class NotfoundPageComponent {
  constructor(private loggingService: LoggingService,private titleService: Title) {
    this.titleService.setTitle( 'Page Not Found' );
    }
}
